<template lang="pug">
.LndGMP
  .LndSection.--pad.__intro
    img(:src="L.intro.img")
    .__txt
      h3(v-html="L.intro.header")
      p(v-html="L.intro.content")

  .LndSection.--pad.__cm.--listed
    .__header
      img.__logo(:src="L.cm.logo")
      span(v-html="L.cm.header")

    .__ul-wrap: ul
      p(v-html="L.cm.content.header")
      li(v-for="li of L.cm.content.list", v-html="li")

  .LndSection.--pad.__dv.--listed
    .__header
      img.__logo(:src="L.dv.logo")
      span(v-html="L.dv.header")

    .__ul-wrap: ul
      p(v-html="L.dv.content.header")
      li(v-for="li of L.dv.content.list", v-html="li")

  .LndSection.--pad.__searchAds.--2cols
    .__header
      img.__logo(:src="L.searchAds.logo")
      span(v-html="L.searchAds.header")
    .__content
      p(v-html="L.searchAds.content")
      .__img(:style="{ backgroundImage: `url(${ L.searchAds.img })` }")

  .LndSection.--pad.__studio.--2cols
    .__header
      img.__logo(:src="L.studio.logo")
      span(v-html="L.studio.header")
    .__content
      p(v-html="L.studio.content")
      .__img(:style="{ backgroundImage: `url(${ L.studio.img })` }")

  .LndSection.--pad.__gAnalytics.--2cols
    .__header
      img.__logo(:src="L.gAnalytics.logo")
      span(v-html="L.gAnalytics.header")
    .__content
      p(v-html="L.gAnalytics.content")
      .__img(:style="{ backgroundImage: `url(${ L.gAnalytics.img })` }")

  .LndSection.--pad.__optimize.--2cols
    .__header
      img.__logo(:src="L.optimize.logo")
      span(v-html="L.optimize.header")
    .__content
      p(v-html="L.optimize.content.join('<br><br>')")
      .__img(:style="{ backgroundImage: `url(${ L.optimize.img })` }")

  .LndSection.--pad
    LndServices.l-mw(:header="L.cases.header")

  .LndSection.--pad
    LndClients.l-mw
      //- LndAchs.l-mw

  .LndSection.--pad
    LndContacts.l-mw
</template>
<script>
import LndServices from 'components/LndServices';
import LndClients from 'components/LndClients';
import LndContacts from 'components/LndContacts';
import LndAchs from 'components/LndAchs';

import content from 'content';

export default {
  static: () => ({
    L: content.gmp,
  }),

  components: {
    LndServices,
    LndClients,
    LndContacts,
    LndAchs,
  },
};

</script>
<style>
.LndGMP {
  --content-pad-h: 65px;

  display: block;
  z-index: -2;

  .__intro {
    h3 {
      margin-bottom: 40px;

      font-weight: 500;
      font-size: 35px;
      line-height: 1.38;
      letter-spacing: -0.065em;
    }
  }

  p,
  li {
    font-size: 14px;
    line-height: 25px;
    letter-spacing: -0.01em;
  }

  .__header {
    position: relative;

    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 40px;
    padding-left: var(--content-pad-h);

    font-weight: 500;
    font-size: 22px;
    line-height: 35px;
    letter-spacing: -0.01em;
    text-align: left;

    .__logo {
      position: absolute;
      left: 0;
    }
  }

  .__intro {
    display: flex;
    gap: 46px;
  }

  .--2cols {

    .__img {
      background-color: white;
      background-repeat: no-repeat no-repeat;
      background-position: center center;
      background-size: contain;
    }
  }

  .LndSection:before { display: none !important }

  .LndClients {
    .__partners { display: none; }
  }
}

/*LG*/
@media (min-width: 741px) {
  .LndGMP {
    .__intro {
      h3 { margin-bottom: 50px; }

      p {
        font-weight: 400;
        font-size: 20px;
        line-height: 180%;
        letter-spacing: -0.065em;
      }

      img {
        width: 57%;
        max-width: 640px;
      }

      .__txt { width: 43% }
    }

    .__logo {
      max-height: 36px;
    }

    .--listed {
      flex-direction: column;
      h3 { width: 100% }

      .__ul-wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;

        min-height: 400px;
        padding: 30px var(--content-pad-h);

        background-color: rgba(255, 255, 255, .1);
      }

      ul {
        display: flex;
        gap: 48px;
        --n: 4;

        p {
          font-weight: bold;
        }

        > * {
          width: calc(100% / var(--n));
        }
      }
    }

    .--2cols {
      flex-direction: column;
      h3 { width: 100% }

      .__content {
        display: flex;

        p {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 41%;
          padding: var(--content-pad-h);

          font-weight: bold;

          background: rgba(255, 255, 255, .1);
        }
      }

      .__img {
        width: 59%;
        min-height: 408px;
      }
    }
  }
}

/*SM*/
@media (max-width: 740px) {
  .LndGMP {

    .LndSection {
      min-height: min(100vh, 620px);
    }

    p {
      font-weight: 700;
      font-size: 14px;
      line-height: 25px;
      letter-spacing: -0.01em;
    }

    .__intro {
      flex-direction: column;
      gap: 58px;

      img { width: 100% }

      p {
        font-weight: 400;
        font-size: 20px;
        line-height: 180%;
        letter-spacing: -0.065em;
      }
    }

    .__logo {
      max-height: 41px;
    }

    .--listed {
      flex-direction: column;

      ul {
        display: flex;
        flex-direction: column;
        gap: 30px;
      }
    }

    .--2cols {
      flex-direction: column;

      .__content {
        display: flex;
        flex-direction: column;
        gap: 80px;
      }

      .__img {
        --w: calc(100% + var(--page-pad) * 2);
        width: var(--w);
        /*height: calc(var(--w) * 0.58);*/
        height: var(--w);
        /*min-height: 185px;*/
        min-height: 225px;
        margin-left: calc(-1 * var(--page-pad));
      }
    }
  }
}
</style>
